<template>
  <div>
    <modal class="block cursor-pointer select-none" title="Solicitar registro de financiadora"
           id="request-funder-modal"
           show-cancel-button
           cancel-button-text="Cancelar"
           big
           :processing="saving"
           :ok-callback="validateForm">
      <form id="frm-funder" @submit.prevent="">
        <div class="form-group mt-2">
          <label class="font-weight-normal"
                 for="title">Nombre de la financiadora: *</label>
          <input type="text"
                 id="title"
                 v-model="title"
                 class="form-control"
                 name="title"
                 placeholder="Especifique el nombre de la tarea."/>
        </div>
        
        <div class="form-group mt-2">
          <label class="font-weight-normal"
                 for="description">Descripción:</label>
          <textarea type="text"
                    id="description"
                    v-model="description"
                    class="form-control"
                    name="description"
                    rows="5"
                    cols="5"
                    placeholder="Escriba breve descripción de la financiadora."></textarea>
        </div>
        
        <div class="form-group">
          <label class="font-weight-normal"
                 for="origin">Procedencia de la financiadora: *</label>
          <select id="origin"
                  v-model="origin"
                  class="form-control"
                  name="origin">
            <option value="" disabled>Seleccione la procedencia.</option>
            <option v-for="origin in origins"
                    :value="origin.title"
                    :key="origin.id">{{ origin.title }}
            </option>
          </select>
        </div>
        
        <div class="form-group">
          <label class="font-weight-normal"
                 for="institution">Institución de la financiadora: *</label>
          <select id="institution"
                  v-model="institution"
                  class="form-control"
                  name="institution"
                  type="text">
            <option value="" disabled>Seleccione una institución.</option>
            <option v-for="institution in institutions"
                    :value="institution.title"
                    :key="institution.id">{{ institution.title }}
            </option>
          </select>
        </div>
      </form>
    </modal>
  </div>
</template>

<script>
  import Modal from '../ui/Modal'
  import { mapActions, mapGetters } from 'vuex'
  import 'jquery-validation'
  import { AlertManager } from '../utils/AlertManager'
  
  export default {
    name: 'RequestFunderModal',
    components: {
      Modal,
    },
    props: {
      funderSaved: Function,
    },
    data () {
      return {
        saving: false,
        title: '',
        description: '',
        origin: '',
        institution: '',
        origins: [],
        institutions: [],
        $form: null,
      }
    },
    methods: {
      ...mapActions({
        getFunderOrigins: 'protocols/getFunderOrigins',
        getFunderInstitutions: 'protocols/getFunderInstitutions',
        saveFunder: 'protocols/saveRequestedFunder',
      }),
      
      async loadData () {
        this.origins      = await this.getFunderOrigins()
        this.institutions = await this.getFunderInstitutions()
      },
      async requestFunder () {
        const {
                protocol,
                title,
                description,
                origin,
                institution,
              } = this
        
        this.saving = true
        
        const response = await this.saveFunder({
          title,
          description,
          origin,
          institution,
          protocol_id: protocol.id,
        })
        
        this.saving = false
  
        return response
      },
      async validateForm () {
        if (this.$form.valid()) {
          const {
                  status,
                  error,
                  message,
                } = (await this.requestFunder()).data
          
          if (status === 'error') {
            AlertManager.error(error)
            
            return
          }
          
          this.clearForm()
          
          AlertManager.success(message)
          
          if(this.funderSaved) {
            this.funderSaved()
          }
        }
      },
      
      clearForm() {
        this.title = ''
        this.description = ''
        this.origin = ''
        this.institution = ''
      }
    },
    computed: {
      ...mapGetters({
        protocol: 'protocols/selectedProtocol',
      }),
    },
    mounted () {
      this.loadData()
      
      const view = this
      
      this.$form = $('#frm-funder')
      
      this.$form.validate({
        highlight: function (element, errorClass, validClass) {
          $(element).addClass('is-invalid')
        },
        unhighlight: function (element, errorClass, validClass) {
          $(element).removeClass('is-invalid')
        },
        errorPlacement: function (label, element) {
          if (element.hasClass('select2-input')) {
            label.insertAfter(element.siblings('span.select2'))
          }
          else if (element.is(':radio') || element.is(':checkbox')) {
            label.insertAfter($('[data-name=\'' + element.attr('name') + '\']'))
          }
          else {
            label.insertAfter(element)
          }
          
          label.addClass('invalid-feedback')
        },
        rules: {
          title: {
            required: true,
          },
          origin: {
            required: true,
          },
          institution: {
            required: true,
          },
        },
        messages: {
          title: {
            required: 'Este campo es requerido.',
          },
          origin: {
            required: 'Este campo es requerido.',
          },
          institution: {
            required: 'Este campo es requerido.',
          },
        },
        async submitHandler () {
          await view.requestFunder()
        },
      })
    },
  }
</script>
